"use client"

import { motion, AnimatePresence } from 'framer-motion'
import { usePathname } from 'next/navigation'
import { ReactNode, useEffect, useState } from 'react'

interface PageTransitionProps {
  children: ReactNode
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const pathname = usePathname()
  // Estado para controlar se estamos navegando para a home
  const [isNavigatingToHome, setIsNavigatingToHome] = useState(false)
  
  useEffect(() => {
    // Detectar navegação para a home
    if (pathname === '/') {
      setIsNavigatingToHome(true)
    } else {
      setIsNavigatingToHome(false)
    }
  }, [pathname])

  const variants = {
    hidden: { opacity: 0, x: -200, y: 0 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 0, x: 0, y: -100 },
  }

  // Para a home, fazemos uma transição mais simples para evitar problemas
  if (isNavigatingToHome) {
    return (
      <div className="flex-1">
        {children}
      </div>
    )
  }

  // Para todas as outras páginas, usamos a animação normal
  return (
    <AnimatePresence mode="wait">
      <motion.main
        key={pathname}
        initial="hidden"
        animate="enter"
        exit="exit"
        variants={variants}
        transition={{ type: 'linear', duration: 0.5 }}
        className="flex-1"
      >
        {children}
      </motion.main>
    </AnimatePresence>
  )
}

export default PageTransition